import React from 'react'
import { updateObject } from 'helpers/objectHelpers'
import FormInputNumber from 'components/forms/FormInputNumber'

const ColumnsContent = ({
  valueContent,
  onChangeContent,
}) => {
  const { gutter = '' } = valueContent
  const handleChange = (val, key) => {
    return onChangeContent(updateObject(valueContent, { [key]: val }))
  }
  return (
    <FormInputNumber
      label="Gutter"
      value={gutter}
      onChange={(val) => handleChange(val, 'gutter')}
    />
  )
}

ColumnsContent.propTypes = {}
ColumnsContent.defaultProps = {}

export default ColumnsContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/columns/ColumnsContent.js